import styles from '../../assets/styles/Onboarding/Forms.module.scss';
import { PageLoader } from '../../components';
import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { Formik } from 'formik';

const OtpForm = ({ onSubmit, loading }) => {
	const [otp, setOtp] = useState('');

	return (
		<Formik
			initialValues={{
				otp: '',
			}}
			onSubmit={onSubmit}>
			{({ handleChange, handleBlur, values, errors, touched }) => (
				<form onSubmit={onSubmit}>
					<div style={{ marginTop: '2rem' }}>
						<label htmlFor="otp" className={styles.form__label}>
							Enter OTP
						</label>
						{loading ? (
							<PageLoader title="Processing" loading={loading} />
						) : (
							<div className={styles.otp__group}>
								<OtpInput
									value={otp}
									onChange={otp => {
										setOtp(otp);
										if (otp >= 10000) {
											onSubmit(otp);
										}
									}}
									numInputs={5}
									inputStyle={{
										fontSize: '2.4rem',
										fontFamily: 'inherit',
										width: '6rem',
										height: '6rem',
										margin: '.4rem',
										borderTop: '0px',
										border: '1px solid #4A4A68',
										borderRadius: '1rem',
										display: 'block',
										outline: 'none',
										textAlign: 'center',
										marginRight: '2rem',
									}}
									containerStyle={
										{
											// margin: '20px auto',
											// padding: '10px',
										}
									}
									isInputNum
								/>
							</div>
						)}
					</div>
				</form>
			)}
		</Formik>
	);
};

export default OtpForm;
